import Reveal from "@/components/feature/Reveal";

const expertise = [
  {
    icon: "ri-restaurant-line",
    title: "Restaurant Operations",
    text: "Focused on efficient, thoughtful restaurant operations designed to support quality, consistency, and an exceptional guest experience.",
  },
  {
    icon: "ri-service-line",
    title: "Guest Experience",
    text: "We believe hospitality is about creating welcoming environments where every detail contributes to how guests feel and remember their experience.",
  },
  {
    icon: "ri-award-line",
    title: "Operational Excellence",
    text: "A disciplined approach to service, standards, and operations helps create sustainable and successful hospitality businesses.",
  },
];

export default function Expertise() {
  return (
    <section id="hospitality" className="bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-10">
        <Reveal className="text-center max-w-2xl mx-auto">
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-primary-600 font-medium">
            Our Expertise
          </p>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight tracking-tight">
            Our Approach to Hospitality
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {expertise.map((item, i) => (
            <Reveal key={item.title} delay={i * 120}>
              <div className="group bg-background-50 border border-background-200/70 rounded-lg p-8 md:p-10 h-full transition-all duration-300 hover:-translate-y-1.5">
                <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-primary-700 transition-colors duration-300 group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${item.icon} text-2xl md:text-3xl`}></i>
                </span>
                <h3 className="mt-6 font-heading text-xl md:text-2xl text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-4 text-foreground-600 leading-relaxed font-light">
                  {item.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}